import { Card } from "antd";
import React from "react";
import Utils from "../../utils/Utils";

function TwoWayFirstSec({ interviewData }) {
  return (
    <div className="report-first-sec flex flex-col md:flex-row gap-y-[.5rem] gap-x-[.8rem] w-full">
      <Card className="md:w-[50%] w-full bg-[#103662] text-white text-[.95rem] md:text-[1.05rem] rounded-2xl font-semibold">
        <div className="flex gap-[.4rem]">
          <p className="w-[40%] text-[#D0D5DD]">Interview ID</p>
          <p className="w-[60%] text-[#FCFCFD] break-all">
            {interviewData?.interviewId || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.4rem] mt-2">
          <p className="w-[40%] text-[#D0D5DD]">Job title</p>
          <p className="w-[60%] text-[#FCFCFD] break-words">
            {interviewData?.jobTitle || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.4rem] mt-2">
          <p className="w-[40%] text-[#D0D5DD]">Company name</p>
          <p className="w-[60%] text-[#FCFCFD] break-words">
            {interviewData?.companyName || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.4rem] mt-2">
          <p className="w-[40%] text-[#D0D5DD]">Duration</p>
          <p className="w-[60%] text-[#FCFCFD]">
            {Utils.convertSecondsToTime(interviewData?.interviewDuration) || "N/A"}
          </p>
        </div>
      </Card>
      <Card className="md:w-[50%] w-full bg-[#103662] text-white text-[.95rem] md:text-[1.05rem] rounded-2xl font-semibold">
        <div className="flex gap-[.4rem]">
          <p className="w-[40%] text-[#D0D5DD]">Candidate name</p>
          <p className="w-[60%] text-[#FCFCFD] break-words">
            {interviewData?.candidateName || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.4rem] mt-2">
          <p className="w-[40%] text-[#D0D5DD]">Email ID</p>
          <p className="w-[60%] text-[#FCFCFD] break-words	">
            {interviewData?.emailId || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.4rem] mt-2">
          <p className="w-[40%] text-[#D0D5DD]">Timestamp</p>
          <p className="w-[60%] text-[#FCFCFD]">
            {Utils.converToDateMonthYear(
              interviewData?.interviewCompletionDate
            ) || "N/A"}
          </p>
        </div>
        <div className="flex gap-[.4rem] mt-2">
          <p className="w-[40%] text-[#D0D5DD]">IP log</p>
          <p className="w-[60%] text-[#FCFCFD]">
            {interviewData?.ipLog || "N/A"}
          </p>
        </div>
      </Card>
    </div>
  );
}

export default TwoWayFirstSec;
